import useSWR from 'swr'

export default function useCustomerKits(all = false, lastActive = false) {
  const { data, error } = useSWR(`/api/account/kits${all ? '?all=true' : lastActive ? '?lastActive=true' : ''}`)

  return {
    kits: data?.kits || undefined,
    isLoading: !error && !data,
    isError: error
  }
}
